module.exports = __webpack_public_path__ + "img/logo12.ae12a07c.png";